import {Button, Stack, Alert, Switch, IconButton, Typography, Checkbox} from '@mui/material';
import Layout from "../../../Frames/Layout";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import moment from 'moment/moment';
import DocumentsModal from './DocumentsModal';
import { useEffect } from 'react';
import API from '../../../../services/API';
import { Delete, Edit, FolderOpen, People } from '@mui/icons-material';
import Grid from '../../../Tools/Grid';
import DpcSessionStatus from '../../../Inputs/DpcSessionStatus';
import BalanceModal from './BalanceModal';
//import ResetLogs from './ResetLogs';

export default function List(){

    const {actionId} = useParams()
    const [action, setAction] = useState(null)
    const [sessions, setSessions] = useState(null)
    const [status, setStatus] = useState('loading')
    const [documents, setDocuments] = useState(null)
    const [balance, setBalance] = useState(null)

    const columns = [
        {
            field: 'number',
            headerName: 'Numéro',
            width: 80,
            type: 'number',
            valueGetter: p => parseFloat(p.row.number),
            renderCell: p => p.row.number,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'start',
            headerName: 'Début',
            width: 120,
            type: 'date',
            valueGetter: p => new Date(p.row.start + 'T00:00:00.000Z'),
            renderCell: p => moment(p.value).format('DD/MM/YYYY'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'end',
            headerName: 'Fin',
            width: 120,
            type: 'date',
            valueGetter: p => new Date(p.row.end + 'T00:00:00.000Z'),
            renderCell: p => moment(p.value).format('DD/MM/YYYY'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'registrantsCount',
            headerName: 'Inscrits',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.registrantsCount,
            renderCell: p => 
                <Button 
                    component={Link} 
                    to={`/admin/dpc/sessions/${p.row.id}/registrations`}
                    size='small'
                    startIcon={<People />}
                >
                    {p.value.toLocaleString()}
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'signaturesCount',
            headerName: 'Attestations',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.signaturesCount,
            renderCell: p => p.value.toLocaleString(),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'revenue',
            headerName: 'Revenu',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.revenue,
            renderCell: p => 
                <span>{p.value.toLocaleString()}<small>€</small></span>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'open',
            headerName: 'Ouverte',
            width: 90,
            type: 'boolean',
            valueGetter: p => !p.row.closed,
            renderCell: p => 
                <Switch 
                    checked={p.value} 
                    onClick={() => updateSession({...p.row, closed: !p.row.closed})}
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'paid',
            headerName: 'Soldé',
            headerAlign: 'center',
            width: 60,
            type: 'boolean',
            align: 'center',
            valueGetter: p => p.row.paidAt ? true : false,
            renderCell: p =>
                <Checkbox 
                    onChange={(_, value) => handleBalanceCheck(value, p.row)}
                    checked={p.value}
                    size="small"
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'paidAt',
            headerName: 'Soldé le',
            width: 110,
            type: 'date',
            valueGetter: p => p.row.paidAt ? moment(p.row.paidAt).toDate() : null,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'balanceAmount',
            headerName: 'Solde €',
            width: 90,
            type: 'number',
            valueGetter: p => p.row.balanceAmount
        },
        {
            field: 'documents',
            headerName: 'Télécharger',
            width: 150,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <Button
                    size="small"
                    startIcon={<FolderOpen />}
                    onClick={() => setDocuments(p.row)}
                >
                    Documents
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'status',
            headerName: 'Demande de solde',
            width: 230,
            valueGetter: p =>  p.row.status.title,
            renderCell: p => 
                <DpcSessionStatus 
                    value={p.row.status}
                    onChange={status => updateSession({...p.row, status})}
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'actions',
            headerName: '',
            width: 100,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <Stack direction='row'>
                    <IconButton 
                        component={Link} 
                        to={`/admin/dpc/actions/${actionId}/sessions/${p.value}`} 
                        size='small'
                    >
                        <Edit />
                    </IconButton>
                    <IconButton 
                        onClick={() => handleDelete(p.value)}
                        size='small'
                    >
                        <Delete />
                    </IconButton>
                </Stack>,
            aggregable: false,
            groupable: false,
        },
        /*{
            field: 'resetLogs',
            headerName: 'Logs',
            width: 150,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <ResetLogs session={p.row} />,
            aggregable: false,
            groupable: false,
        },*/
    ];

    useEffect(() => {

        API.get(`/dpc/actions/${actionId}`)
            .then(r => setAction(r.data))

        API.get(`/dpc/actions/${actionId}/sessions`)
            .then(r => {
                setSessions(r.data)
                setStatus('ready')
            })
            .catch(e => setStatus('error'))

    }, [actionId])
        

    const handleDelete = id => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cette session ?");
        if(!ok) return false;
        
        const old = [...sessions];

        API.delete(`/dpc/sessions/${id}`)
            .catch(e => setSessions(old))

        setSessions([...sessions].filter(s => s.id !== id))
    }

    const updateSession = session => {
        const oldSessions = [...sessions];
        let newSessions = [...sessions];
        
        const index = newSessions.findIndex(s => s.id === session.id);
        newSessions[index] = session;

        setSessions(newSessions)

        API.put(`/dpc/sessions/${session.id}`, session)
            .catch(e => setSessions(oldSessions))
    }

    const handleBalanceCheck = (value, session) => {
        if (value) {
            setBalance(session)
        } else {
            const ok = window.confirm("Êtes-vous sûr de vouloir effacer le solde de cette session ?");
            if (!ok) return false;
            updateSession({...session, 
                balanceAmount: 0,
                paidAt: null
            });
        }
    }

    const handleBalanceSubmit = session => {
        updateSession(session);
        setBalance(null);
    }

    return <Layout title="Sessions DPC" tab="dpc" menu="admin" back={true}>

        {status === 'error' && 
            <Alert severity="error">
                Une erreur s'est produite. Les données n'ont pas pu être récupérées.
            </Alert>
        }


        <Stack direction='row' justifyContent='space-between' alignItems="center" flexWrap="wrap" sx={{mb: 1}}>

            <Typography><b>{actionId}</b> {action ? ` | ${action?.title}` : ''}</Typography>

            <Link to={`/admin/dpc/actions/${actionId}/sessions/new`}>
                <Button variant='contained' sx={{mb: 1, ml: 1}}>Ajouter</Button>
            </Link>

        </Stack>

        <Grid
            id={`sessions${actionId}Grid`}
            columns={columns}
            rows={sessions}
            toolbar
        />

        <DocumentsModal
            session={documents}
            onClose={() => setDocuments(null)}
        />

        <BalanceModal
            session={balance}
            onClose={() => setBalance(null)}
            onSubmit={handleBalanceSubmit}
        />

    </Layout>
}
